require('./core');

require('./builders/resource_builder');
require('./builders/resource_category_builder');
require('./servants/resource_categories_servant');

require('./commands/load_resource_categories_command');
require('./commands/load_resources_command');
require('./commands/select_resource_category_command');

require('./components/resource_tabs/resource_tabs');
require('./components/resource_card/resource_card');

require('./config/resources_configuration');
require('./config/route_configuration');

require('./datasources/resource_categories_datasource');
require('./datasources/resources_datasource');

require('./views/resource_categories/resource_categories');

require('./queries/resource_categories_alphabetical_query');
require('./queries/resource_categories_query');



// WEBPACK FOOTER //
// ./app/lib/resources/main.ts